﻿/*!
    *
    * Wijmo Library 5.20251.34
    * https://developer.mescius.com/wijmo
    *
    * Copyright(c) MESCIUS inc. All rights reserved.
    *
    * Licensed under the End-User License Agreement For MESCIUS Wijmo Software.
    * us.sales@mescius.com
    * https://developer.mescius.com/wijmo/licensing
    *
    */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { VueApi, WjComponentBehavior } from '@mescius/wijmo.vue2.base';
import * as wjcViewer from '@mescius/wijmo.viewer';
var WjReportViewerBehavior = /** @class */ (function (_super) {
    __extends(WjReportViewerBehavior, _super);
    function WjReportViewerBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjReportViewerBehavior.tag = 'wj-report-viewer';
    WjReportViewerBehavior.props = [
        'isDisabled',
        'tabOrder',
        'serviceUrl',
        'filePath',
        'fullScreen',
        'zoomFactor',
        'zoomMode',
        'mouseMode',
        'viewMode',
        'requestHeaders',
        'parameters',
        'paginated',
        'reportName'
    ];
    WjReportViewerBehavior.events = [
        'initialized',
        'gotFocus',
        'lostFocus',
        'refreshing',
        'refreshed',
        'invalidInput',
        'pageIndexChanged',
        'queryLoadingData',
        'beforeSendRequest'
    ];
    WjReportViewerBehavior.changeEvents = {
        'fullScreenChanged': ['fullScreen'],
        'zoomFactorChanged': ['zoomFactor'],
        'zoomModeChanged': ['zoomMode'],
        'mouseModeChanged': ['mouseMode'],
        'viewModeChanged': ['viewMode'],
    };
    WjReportViewerBehavior.classCtor = function () { return wjcViewer.ReportViewer; };
    return WjReportViewerBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.viewer.ReportViewer} control.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.viewer.ReportViewer} control it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjReportViewer = WjReportViewerBehavior.register();
function registerV3WjReportViewer(app) {
    app.component(WjReportViewerBehavior.tag, WjReportViewer);
}
var WjPdfViewerBehavior = /** @class */ (function (_super) {
    __extends(WjPdfViewerBehavior, _super);
    function WjPdfViewerBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjPdfViewerBehavior.tag = 'wj-pdf-viewer';
    WjPdfViewerBehavior.props = [
        'isDisabled',
        'tabOrder',
        'serviceUrl',
        'filePath',
        'fullScreen',
        'zoomFactor',
        'zoomMode',
        'mouseMode',
        'viewMode',
        'requestHeaders'
    ];
    WjPdfViewerBehavior.events = [
        'initialized',
        'gotFocus',
        'lostFocus',
        'refreshing',
        'refreshed',
        'invalidInput',
        'pageIndexChanged',
        'queryLoadingData',
        'beforeSendRequest'
    ];
    WjPdfViewerBehavior.changeEvents = {
        'fullScreenChanged': ['fullScreen'],
        'zoomFactorChanged': ['zoomFactor'],
        'zoomModeChanged': ['zoomMode'],
        'mouseModeChanged': ['mouseMode'],
        'viewModeChanged': ['viewMode'],
    };
    WjPdfViewerBehavior.classCtor = function () { return wjcViewer.PdfViewer; };
    return WjPdfViewerBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.viewer.PdfViewer} control.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.viewer.PdfViewer} control it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjPdfViewer = WjPdfViewerBehavior.register();
function registerV3WjPdfViewer(app) {
    app.component(WjPdfViewerBehavior.tag, WjPdfViewer);
}
export function registerViewer(app) {
    if (VueApi.isV3Plus) {
        registerV3WjReportViewer(app);
        registerV3WjPdfViewer(app);
    }
}
